import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  addSubject,
  getAddSubjectStatus,
  setAddSubjectIdleStatus,
} from "../../../redux/slice/topicSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";

const AddSubjectForm = ({ topicId }) => {
  const dispatch = useDispatch();
  const [subjectName, setSubjectName] = useState("");
  const [subjectNameError, setSubjectNameError] = useState("");

  const status = useSelector(getAddSubjectStatus);

  const handleAddSubject = async (e) => {
    e.preventDefault();
    if (!subjectName) {
      setSubjectNameError("Subject name is required");
    } else {
      const data = { topicId, subjectName };
      try {
        await dispatch(addSubject(data)).unwrap();
        setSubjectName("");
      } catch (err) {
        setSubjectNameError(err.message);
      }
    }
  };
  return (
    <section className="flex flex-col gap-4 sm:pl-4 py-2">
      {status === "loading" ? <Loading /> : null}
      {status === "success" ? (
        <AlertBox
          type="success"
          message="Subject added successfully"
          toDispatch={setAddSubjectIdleStatus}
        />
      ) : null}

      <form onSubmit={handleAddSubject} className="flex flex-col gap-1">
        <div className="flex flex-row sm:gap-6 gap-3 items-center">
          <input
            type="text"
            id="subjectName"
            name="subjectName"
            value={subjectName}
            onChange={(e) => {
              setSubjectName(e.target.value);
              setSubjectNameError("");
            }}
            className="admin-input-box text-textSecondary"
            placeholder="Add Subject"
            autoFocus
          />
          <div>
            <button
              type="submit"
              className="border border-blue-600 text-blue-600 h-[32px] px-4 rounded-[4px]"
            >
              <FaPlus />
            </button>
          </div>
        </div>
        <span className="pl-4 text-[12px] italic text-red-500">
          {subjectNameError}
        </span>
      </form>
    </section>
  );
};

export default AddSubjectForm;
